import { Pipe, type PipeTransform } from '@angular/core';
import { toLocalDate } from '@quipex/core/primitives';

@Pipe({
    name: 'qpxToLocalDate',
})
export class ToLocalDatePipe implements PipeTransform {
    /**
     * Transforms an ISO date string into a Date object with the system's local time zone.
     * Falls back to current date/time if invalid.
     */
    transform(value: string): Date {
        if (!value || typeof value !== 'string') {
            return new Date();
        }
        try {
            return toLocalDate(value);
        } catch {
            return new Date();
        }
    }
}
